<template>
  <div class="edit-menu">
    <h1>Editar Menú</h1>
    <div class="alert alert-info" v-if="loading && !error">Cargando menú...</div>
    <div class="alert alert-danger" v-if="error">{{ error }}</div>
    
    <div class="card p-4 bg-light" v-if="!loading && !error">
      <form @submit.prevent="submitForm" v-if="!loading && !error">
        <div class="mb-3">
          <label for="menuId" class="form-label">ID</label>
          <input 
            type="text" 
            class="form-control" 
            id="menuId" 
            v-model="menu.MenuId" 
            disabled
          >
        </div>
        <div class="mb-3">
          <label for="nombre" class="form-label">Nombre</label>
          <input 
            type="text" 
            class="form-control" 
            id="nombre" 
            :value="menu.Nombre"
            @input="updateField('Nombre', $event.target.value)"
            required
          >
        </div>
        <div class="mb-3">
          <label for="menuPadre" class="form-label">Menu Padre</label>
          <input 
            type="text" 
            class="form-control" 
            id="menuPadre" 
            :value="menu.MenuPadre"
            @input="updateField('MenuPadre', $event.target.value)"
          >
        </div>
        <div class="mb-3">
          <label for="orden" class="form-label">Orden</label>
          <input 
            type="number" 
            class="form-control" 
            id="orden" 
            :value="menu.Orden"
            @input="updateField('Orden', parseInt($event.target.value) || 0)"
          >
        </div>
        <div class="d-flex gap-2">
          <button type="submit" class="btn btn-primary" :disabled="saving">
            {{ saving ? 'Guardando...' : 'Guardar Cambios' }}
          </button>
          <button type="button" class="btn btn-secondary" @click="goBack">
            Cancelar
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { useAccessControl } from '@/composables/useAccessControl'
import { EditMenuController } from '../controllers/EditMenuCtrl.js';

export default {
  name: 'EditMenuView',
  props: ['id'],
  setup() {
    const { requiresAuth, requiresMenuPermission } = useAccessControl({
      requiresAuth: true,
      requiresMenuPermission: true
    })

    return {
      requiresAuth,
      requiresMenuPermission
    }
  },
  data() {
    return {
      controller: new EditMenuController()
    }
  },
  computed: {
    menu() {
      return this.controller.getMenu();
    },
    parentMenus() {
      return this.controller.getParentMenus();
    },
    loading() {
      return this.controller.isLoading();
    },
    saving() {
      return this.controller.isSaving();
    },
    error() {
      return this.controller.getError();
    }
  },
  async mounted() {
    try {
      await this.controller.init(this.id);
    } catch (error) {
      console.error('Error al inicializar:', error);
      this.$alert.error('Error al cargar los datos del menú.');
    }
  },
  methods: {
    async submitForm() {
      try {
        const result = await this.controller.updateMenu();
        
        if (result.success) {
          this.$alert.success(result.message);
          if (result.message !== 'No hay cambios para guardar') {
            this.$router.push('/menus');
          }
        } else {
          this.$alert.error(result.message || 'Error al actualizar el menú.');
        }
      } catch (error) {
        console.error('Error updating menu:', error);
        this.$alert.error(this.controller.getError() || 'Error al actualizar el menú. Por favor, intente de nuevo.');
      }
    },
    updateField(field, value) {
      this.controller.updateField(field, value);
    },
    resetForm() {
      this.controller.resetToOriginal();
    },
    goBack() {
      this.$router.push('/menus');
    }
  }
}
</script>

<style scoped>
.edit-menu {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}
</style>
